import { useAppSelector } from '@store/hooks';

import { useTranslation } from 'react-i18next';

import { Card, CardBody } from '@components/card/card';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Link, useParams } from 'react-router-dom';
import Update from './Update';
import Additions from './Additions/Additions';
import Loading from '@components/Shared/Loader/Loading';
import Revaluations from './Revaluations';
import Retirements from './Retirements';
import Assignation from './Assignation';

const AssetsDetails = () => {
  const { t, i18n } = useTranslation();
  const { AssetsById: data, loading, error } = useAppSelector(a => a.Assets);

  //____________________________

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'الأصول',
              link: null
            },
            {
              name: 'تفاصيـل الأصل',
              link: null
            }
          ]}
          PageName='تفــاصيـــل الأصل'
          subtitle={i18n.language === 'en' ? data.name : data.name2}
        />
      </div>
      <Card>
        {/* <Loading loading={loading} error={error}> */}
        <CardBody className='pt-1'>
          <ul className='nav nav-tabs nav-tabs-v2 ps-4 pe-4 '>
            <li className='nav-item me-3'>
              <Link to='#dataAssets' className='nav-link active' data-bs-toggle='tab'>
                <i className='fa fa-info-circle me-2 text-theme'></i>
                تفاصيل الأصل
              </Link>
            </li>
            <li className='nav-item me-3'>
              <Link to='#AdditionsAssets' className='nav-link' data-bs-toggle='tab'>
                <i className='fa fa-plus-circle me-2 text-theme'></i>
                الإضافات
              </Link>
            </li>
            <li className='nav-item me-3'>
              <Link to='#Revaluations' className='nav-link' data-bs-toggle='tab'>
                <i className='fa fa-sync-alt me-2 text-theme'></i>
                سجل إعادة التقييم
              </Link>
            </li>
            <li className='nav-item me-3'>
              <Link to='#Retirements' className='nav-link' data-bs-toggle='tab'>
                <i className='fa fa-user-tag me-2 text-theme'></i>
                تخصيص الأصل للموظفين
              </Link>
            </li>
          </ul>

          <div className='tab-content py-4 px-1'>
            <div className='tab-pane fade show active' id='dataAssets'>
              <Update />
            </div>
            <div className='tab-pane fade' id='AdditionsAssets'>
              <Additions />
            </div>
            <div className='tab-pane fade' id='Revaluations'>
              <Revaluations />
            </div>
            <div className='tab-pane fade' id='Retirements'>
              {/* <Retirements /> */}
              <Assignation />
            </div>
          </div>
        </CardBody>
        {/* </Loading> */}
      </Card>
    </>
  );
};

export default AssetsDetails;

// {/* تابع لـ  */}
// <div className="col-lg-4">
//   <div className="form-group mb-3">
//     <label className="form-label"> {t('تابع لـ ')}</label>
//     <Select
//       classNamePrefix="react-select"
//       // isLoading={loading3}
//       isSearchable={true}
//       isClearable
//       options={OptionsAssets}
//       value={OptionsAssets?.find((f: any) => f.value === formik.values.parentAssetId)}
//       onChange={(option: any) =>
//         setFieldValue('parentAssetId', option === null ? null : option.value)
//       }
//       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//     />
//   </div>
// </div>
